var translationKey = 'faqs.description';
var walgreens = {
    drawerActionButton: null,
    certificateBalance: true,
    certificateExpirationDays: 90,
    certificateValue: 5,
    disclaimerTranslationKey: 'walgreensDisclaimer',
    es: {
        termsAndConditionsLink: 'https://www.walgreens.com/es/topic/help/generalhelp/mywalgreens-credit-card-terms-of-use.jsp'
    },
    en: {
        termsAndConditionsLink: 'https://www.walgreens.com/topic/help/generalhelp/mywalgreens-credit-card-terms-of-use.jsp'
    },
    howToEarnPointsHeader: 'fullDetailsPage.howToEarnPointsHeader',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: true,
    links: [
        {
            href: 'https://www.walgreens.com/',
            text: 'walgreens.com'
        }
    ],
    translationViewPrintKey: null,
    DUAL_CARD: {
        actionButton: {
            text: 'shopMore.walgreensButtonText',
            link: 'https://documents.syf.com/msp/web/walgreens/3882350_Walgreens_MC_Site'
        },
        banner: 'walgreens-dc-banner.png',
        cashRewardsBalance: true,
        certificateHistoryImg: '',
        certificateHistory: false,
        faqs: 'https://documents.syf.com/msp/web/walgreens/3882350_Walgreens_MC_Site#faq',
        rewardsBalance: true,
        snapshotTranslationKey: translationKey,
        translationKey: 'faqs.walgreensDescription',
        valuePropImg: 'walgreens-valueProp-dc.png',
        en: {
            propositions: [
                {
                    description: 'Earn 10% back in Walgreens Cash rewards on Walgreens brand purchases at Walgreens.*',
                    heading: 'earn',
                    points: '10% back'
                },
                {
                    description: 'Earn 5% back in Walgreens Cash rewards on all other brands and pharmacy purchases at Walgreens.*',
                    heading: 'earn',
                    points: '5% back'
                },
                {
                    description: 'Earn 3% back in Walgreens Cash rewards on grocery store and health & wellness purchases outside of Walgreens.*',
                    heading: 'earn',
                    points: '3% back'
                },
                {
                    description: 'Earn 1% back in Walgreens Cash rewards everywhere Mastercard is accepted.*',
                    heading: 'earn',
                    points: '1% back'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 10% de reembolso en recompensas de Walgreens Cash en compras de la marca Walgreens en Walgreens.*',
                    heading: 'obtenga',
                    points: '10% de reembolso'
                },
                {
                    description: 'Obtenga 5% de reembolso en recompensas de Walgreens Cash en todas las demás marcas y compras de farmacia en Walgreens.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                },
                {
                    description: 'Obtenga 3% de reembolso en recompensas de Walgreens Cash en compras de comestibles y productos para la salud y el bienestar en otras tiendas fuera de Walgreens.*',
                    heading: 'obtenga',
                    points: '3% de reembolso'
                },
                {
                    description: 'Obtenga 1% de reembolso en recompensas de Walgreens Cash en cualquier lugar donde se acepte Mastercard.*',
                    heading: 'obtenga',
                    points: '1% de reembolso'
                }
            ]
        }
    },
    PRIVATE_LABEL: {
        actionButton: {
            text: 'shopMore.walgreensButtonText',
            link: 'https://documents.syf.com/msp/web/walgreens/3882350_Walgreens_PLCC_Site'
        },
        banner: 'walgreens-plcc-banner.png',
        cashRewardsBalance: true,
        certificateHistoryImg: '',
        certificateHistory: false,
        faqs: 'https://documents.syf.com/msp/web/walgreens/3882350_Walgreens_PLCC_Site#faq',
        rewardsBalance: true,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: 'walgreens-valueProp-plcc.png',
        en: {
            propositions: [
                {
                    description: 'Earn 10% back in Walgreens Cash rewards on Walgreens brand purchases at Walgreens.*',
                    heading: 'earn',
                    points: '10% back'
                },
                {
                    description: 'Earn 5% back in Walgreens Cash rewards on all other brands and pharmacy purchases at Walgreens.*',
                    heading: 'earn',
                    points: '5% back'
                }
            ]
        },
        es: {
            propositions: [
                {
                    description: 'Obtenga 10% de reembolso en recompensas de Walgreens Cash en compras de la marca Walgreens en Walgreens.*',
                    heading: 'obtenga',
                    points: '10% de reembolso'
                },
                {
                    description: 'Obtenga 5% de reembolso en recompensas de Walgreens Cash en todas las demás marcas y compras de farmacia en Walgreens.*',
                    heading: 'obtenga',
                    points: '5% de reembolso'
                }
            ]
        }
    }
};
export default walgreens;
